import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import _ from 'lodash'; 
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  httpOptions: any;
  constructor(
    public toastr:ToastrService,
    public loader:NgxUiLoaderService,
    private router:Router,
    private http:HttpClient,
  ) {
  }
  public get(url){
    return this.http.get(environment.baseUrl + url);
  }

  public post(url, data){
    if (this.getCookies('loginData') || localStorage.getItem('loginData')) {
      data.loginInfo = (this.getCookies('loginData'))? JSON.parse(this.getCookies('loginData')).acl : JSON.parse(localStorage.getItem('loginData')).acl;

      }
    return this.http.post(environment.baseUrl + url, data);
  }

  public getMaster(url){
    return this.http.get(environment.masterUrl + url);
  }

  public postMaster(url, data){
    if (this.getCookies('loginData') || localStorage.getItem('loginData')) {
      data.loginInfo = (this.getCookies('loginData'))? JSON.parse(this.getCookies('loginData')).acl : JSON.parse(localStorage.getItem('loginData')).acl;

      }
    return this.http.post(environment.masterUrl + url,data );
  }
  public setCookies(name, value, days?: any): any {
    let date,
      expires;
    if (days) {
      date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toGMTString();
    } else {
      expires = '';
    }
    
    return document.cookie = name + '=' + JSON.stringify(value) + expires + '; path=/';
  }

  public getCookies(cname): any {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  public removeCookies(name, value): any {
    let date,
      expires;
    date = new Date();
    date.setTime(date.getTime());
    expires = '; expires=' + date.toGMTString();

    document.cookie = name + '=' + value + expires + '; path=/';
  }

  public logout() {
    this.removeCookies('currentUsertoken', '');
    this.removeCookies('currentUser', '');
    window.location.href = "/home";
  }

  public startLoader(){
    this.loader.start();
  }

  public stopLoader(){
    this.loader.stop();
  }

  public showSuccess(msg:string){
    this.toastr.success(msg);
  }

  public showError(msg:string){
    this.toastr.error(msg);
  }

}
